import { cn } from "@/lib/cn";

interface SpinnerProps {
  className?: string | undefined;
  label?: string | undefined;
}

/**
 * The spinner itself is decorative; the label is what a screen reader
 * announces, so a loading state is never silence.
 */
export function Spinner({ className, label = "Loading…" }: SpinnerProps) {
  return (
    <span role="status" className={cn("inline-flex items-center gap-2", className)}>
      <span
        aria-hidden="true"
        className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent opacity-70"
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export function FullPageSpinner({ label }: { label?: string | undefined }) {
  return (
    <div className="flex min-h-dvh items-center justify-center text-ink-muted">
      <Spinner label={label} />
      <span aria-hidden="true" className="ml-2 text-sm">
        {label ?? "Loading…"}
      </span>
    </div>
  );
}
